import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ProfileEditor from "./ProfileEditor";
import AdminService from "../services/AdminService";
import PublicService from "../services/PublicService";
import { TRANSLATIONS } from "../services/serviceConstants";

// Admin page for editing a consultant's profile.
const ConsultantEditor = (props) => {
  const { id } = props.match.params;
  const history = useHistory();
  const [consultantName, setConsultantName] = useState("");
  const [showPrivateResumeToggle, setShowPrivateResumeToggle] = useState(true);

  const profileService = {
    getConsultant: () => PublicService.getConsultant(id),
    getProfilePic: () => PublicService.getPublicProfilePic(id),
    uploadProfilePic: (formData) => AdminService.uploadProfilePic(id, formData),
    updateUserInfo: (userInfo) => AdminService.updateUserInfo(id, userInfo),
    updatePrivateResumeStatus: (privateResume) =>
      AdminService.updateUserInfo(id, { privateResume: privateResume }),
    createTranslation: (language, seedFromLanguage) =>
      AdminService.addTranslation(id, language, seedFromLanguage),
    deleteTranslation: (translationId) =>
      AdminService.deleteArrayItem(id, translationId, TRANSLATIONS),
    updateTranslationInfo: (translationId, object) =>
      AdminService.updateTranslationInfo(id, translationId, object),
    createTranslationItem: (translationId, objectToAdd, collectionName) =>
      AdminService.createNestedArrayItem(
        id,
        translationId,
        TRANSLATIONS,
        objectToAdd,
        collectionName
      ),
    updateTranslationItem: (translationId, objectToUpdate, collectionName) =>
      AdminService.updateNestedArrayItem(
        id,
        translationId,
        TRANSLATIONS,
        objectToUpdate,
        collectionName
      ),
    deleteTranslationItem: (translationId, objectToDeleteId, collectionName) =>
      AdminService.deleteNestedArrayItem(
        id,
        translationId,
        TRANSLATIONS,
        objectToDeleteId,
        collectionName
      ),
  };

  const onConsultantLoaded = (consultant) => {
    setConsultantName(
      consultant.firstname && consultant.lastname
        ? `${consultant.firstname} ${consultant.lastname}`
        : consultant.username
    );
    setShowPrivateResumeToggle(
      (consultant.role || "").includes("externaluser") === false
    );
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <IconButton onClick={() => history.push(`/consultantpage/${id}`)}>
            <ArrowBackIcon />
          </IconButton>
          <div style={{ textAlign: "center" }}>
            <h4
              style={{ textAlign: "center", marginTop: "10px" }}
            >{`Editing profile: ${consultantName}`}</h4>
          </div>
          <div>
            <ArrowBackIcon style={{ color: "#FAFAFA" }} />
          </div>
        </div>
      </div>
      <ProfileEditor
        profileService={profileService}
        showPrivateResumeToggle={showPrivateResumeToggle}
        onConsultantLoaded={onConsultantLoaded}
      />
    </>
  );
};

export default ConsultantEditor;
